import { Link } from 'react-router-dom';
import PageHero from '../components/PageHero';
import { heroSubtitleClass, heroTitleClass, motionSafe } from '../constants/heroTypography';
import heroBg from '../assets/img/ic_our_service_background.png';

const sections = [
  {
    title: 'Introduction',
    body: [
      'RAYAN STAR Consultancy & Services W.L.L. (“we”, “us”, “our”) respects your privacy. This Privacy Policy explains how we collect, use, store, and protect personal information when you use our website, contact us, or use our services.',
      'By using this site or submitting information through our contact form, you agree to this policy. If you do not agree, please do not use the site or submit personal data.',
    ],
  },
  {
    title: 'Information we collect',
    body: [
      'We may collect: your name, email address, phone number, and any message or details you choose to provide when you contact us or request information.',
      'We may also collect technical data such as browser type, device information, and general usage patterns through standard web technologies, where applicable.',
    ],
  },
  {
    title: 'How we use your information',
    body: [
      'We use your information to respond to enquiries, provide consultancy and related services, improve our website and communications, and comply with legal obligations.',
      'We do not sell your personal information to third parties.',
    ],
  },
  {
    title: 'Cookies and similar technologies',
    body: [
      'Our site may use cookies or similar tools to operate the site, remember preferences, or understand traffic. You can adjust your browser settings to limit cookies; some features may not work as intended if you do.',
    ],
  },
  {
    title: 'Sharing and retention',
    body: [
      'We may share information with trusted service providers who assist our operations (for example, hosting or email delivery), subject to confidentiality and only as needed.',
      'We retain information only as long as necessary for the purposes described above or as required by law.',
    ],
  },
  {
    title: 'Security',
    body: [
      'We take reasonable technical and organisational measures to protect personal data. No method of transmission over the internet is completely secure; we cannot guarantee absolute security.',
    ],
  },
  {
    title: 'Your choices',
    body: [
      'You may request access to, correction of, or deletion of your personal information where applicable, subject to legal exceptions. Contact us using the details below.',
    ],
  },
  {
    title: 'Changes to this policy',
    body: [
      'We may update this Privacy Policy from time to time. The revised version will be posted on this page with an updated effective date where appropriate.',
    ],
  },
  {
    title: 'Contact us',
    body: [
      'For questions about this Privacy Policy or your personal data, contact us at rayanstarbh@gmail.com or through our Contact page.',
    ],
  },
];

export default function PrivacyPolicy() {
  return (
    <div className="bg-navy-950">
      <PageHero
        title="Privacy Policy"
        subtitle="How we handle your information when you use our website and services."
        backgroundImage={heroBg}
        titleClassName={heroTitleClass}
        subtitleClassName={heroSubtitleClass(motionSafe)}
      />

      <section className="mx-auto max-w-3xl px-4 py-14 sm:px-6 lg:px-8 lg:py-20">
        <p className="text-center text-sm text-white/55">Effective: April 2026</p>

        <div className="mt-10 space-y-10">
          {sections.map((s) => (
            <article key={s.title}>
              <h2 className="font-sans text-lg font-semibold text-white sm:text-xl">{s.title}</h2>
              {s.body.map((p, i) => (
                <p key={`${s.title}-${i}`} className="mt-3 text-justify text-sm leading-relaxed text-white/80 sm:text-base">
                  {p}
                </p>
              ))}
            </article>
          ))}
        </div>

        <p className="mt-12 text-center text-sm text-white/60">
          <Link to="/contact" className="font-semibold text-gold hover:underline">
            Contact us
          </Link>
          {' · '}
          <Link to="/" className="hover:text-white">
            Home
          </Link>
        </p>
      </section>
    </div>
  );
}
